/* The collection intro (RSFY-825): a description clamped by CSS with a
   "Read more" that only shows when the clamp actually hides something. The
   chip counts, the Similar arrows and the related searches subtitle are in
   risify-blocks.js, loaded by the Risify blocks section. */
if (!customElements.get('risify-collection-intro')) {
  class RisifyCollectionIntro extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-intro-text]');
      this.toggle = this.querySelector('[data-intro-toggle]');
      if (this.text && this.toggle) {
        this.toggle.addEventListener('click', () => this.toggleText());
        this.measure();
        /* the clamp hides a different amount at every width */
        if ('ResizeObserver' in window) {
          new ResizeObserver(() => this.measure()).observe(this.text);
        }
      }
    }

    /* Measured with the clamp on. Chromium paints the clamp's ellipsis on
       the last allowed line even when the text ends right there, so when
       nothing is hidden the clamp is lifted (is-unclamped) and the
       ellipsis with it; the next measurement puts it back first. */
    measure() {
      if (this.classList.contains('is-expanded')) return;
      this.classList.remove('is-unclamped');
      const clipped = this.text.scrollHeight - this.text.clientHeight > 2;
      this.toggle.hidden = !clipped;
      this.classList.toggle('is-unclamped', !clipped);
    }

    /* "Read more" opens the clamp, "Show less" closes it again */
    toggleText() {
      const open = this.classList.toggle('is-expanded');
      this.toggle.textContent = open ? 'Show less' : 'Read more';
      if (!open) this.measure();
    }
  }

  customElements.define('risify-collection-intro', RisifyCollectionIntro);
}
